import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import powerByLink from '../images/powerby.png';

const DownloadPdf = props => {

 const [isDownloading, setDownload] = React.useState(false);

 const generateToPdf = () => {
    let canvasArea = document.getElementsByClassName("FootfallInsights_main")[0];
    let parentDiv = document.getElementById("root");
    // Clone the canvas area
    let clone = canvasArea.cloneNode(true);
    // Put powerby logo to the canvas
    let Powerby = document.createElement("IMG");
    Powerby.setAttribute("src", powerByLink);
    Powerby.setAttribute("width", "400");
    Powerby.setAttribute("height", "72");
    Powerby.style.float = "right"
    clone.appendChild(Powerby);
    // Put in the bottom
    parentDiv.appendChild(clone)
    // The cloned one will make a canvas
    let realCanvasCropArea = document.getElementsByClassName("FootfallInsights_main")[1];
    // Disabled the scroll bar
    document.body.style.overflow = "hidden";
    setDownload(true);
    // overwrite owner doc inner height with your div clientHeight
        html2canvas(realCanvasCropArea,{
          width: realCanvasCropArea.offsetWidth,
          height: realCanvasCropArea.offsetHeight + 72,
          x: 0,
          y: 0,
          windowWidth: realCanvasCropArea.offsetWidth,
          scrollX: 0,
          scrollY: 0,
          useCORS: true,

        })
        .then(function(canvas) {
          parentDiv.removeChild(realCanvasCropArea)
          document.body.style.overflow = "auto";
          var myImage = canvas.toDataURL("image/png");
          var doc = new jsPDF("p", "pt", [canvas.width ,canvas.height]);
          var width = doc.internal.pageSize.getWidth();
          var height = doc.internal.pageSize.getHeight()
          doc.addImage(myImage, 'PNG', 0, 0, width, height);
          doc.save(props.reportType + '.pdf');
          setDownload(false);
        });
  }

 return (
  <div className="DownloadCSVButton" data-html2canvas-ignore="true">
  <Button
    size="download-csv"
    label='Download Pdf'
    onClick={() => generateToPdf()}
    disabled={props.isDisabled}
    loading={isDownloading}
  />
</div>
)
  }

DownloadPdf.propTypes = {
  reportType: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired
};


export default DownloadPdf;
